<template>
  <div>

    <div class="card card-info" id="divEmployeeList">
      <div class="card-header">
        <a href="../Admission/EntryTestCreate" class="btn btn-sm btn-outline-secondary btn-default"><i class="fa fa-plus text-black-50"> <b>Add New</b></i></a>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive-sm">
              <table id="entryTestTable" style="width: 100%" class="table table-bordered table-sm">
                <thead class="bg-info">
                  <tr>
                    <th>Degree</th>
                    <th>Session</th>
                    <th>Test Title</th>
                    <th>Timings</th>
                    <th style="width: 300px; white-space: nowrap"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in tests">
                    <td>{{item._Degree}}</td>
                    <td>{{item._Session}}</td>
                    <td>{{item.Name}}</td>
                    <td>{{item.Timings}}</td>
                    <td>
                      <a :href="'../Admission/EntryTestCreate?id=' + item.ID" target='_blank' class='btn btn-sm btn-primary'>Edit</a>
                      <a :href="'../Admission/EntryTestPrint?id=' + item.ID" target='_blank' class='btn btn-sm btn-success'>Print</a>
                      <a :href="'../Admission/EntryTestAttendanceSheetPrint?id=' + item.ID" target='_blank' class='btn btn-sm btn-warning'>Attend. Sheet</a>
                      <a :href="'../Admission/EntryTestMarkSheetPrint?id=' + item.ID" target='_blank' class='btn btn-sm btn-info' id='" + row.ID + "'>Mark Sheet</a>
                      <a :href="'../Admission/EntryTestMarkSheetPrintManual?id=' + item.ID" target='_blank' class='btn btn-sm btn-info' id='" + row.ID + "'>Mark Sheet Manual</a>
                      <!--<a :href="'../Admission/ProgramWiseEntryTestAverage?id=' + item.ID" target='_blank' class='btn btn-sm btn-info' id='" + row.ID + "'>Test Marks Graph</a>-->
                      <button class="btn btn-sm btn-info" type="button" v-on:click="loadHalls(item.ID)">Email Admit Card</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div id="modal" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h4 class="modal-title">Halls</h4>
          </div>
          <div class="modal-body">
            <table class="table table-bordered table-sm">
              <tr class="bg-info">
                <th>Sr.</th>
                <th>Hall No</th>
                <th>Total Students</th>
                <th>Email Not Sent To</th>
                <th align="center">Action</th>
              </tr>
              <tr v-for="(item, ind) in halls">
                <td>{{ind + 1}}</td>
                <td>{{item.HallName}}</td>
                <td align="center">{{item.TotalStudents}}</td>
                <td align="center">{{item.RemainingStudents}}</td>
                <td align="center">
                  <button type="button" class="btn btn-sm btn-info" v-on:click="sendEmail(item.HallID, 'All')">Send Email To All Student</button>
                  <button type="button" class="btn btn-sm btn-primary" v-on:click="sendEmail(item.HallID, 'Remaining')">Send Email To Remaining Students</button>
                </td>
              </tr>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  const axios = require('axios').default;

  export default ({
    data() {
      return {
        tests: [],
        halls: [],
        testID: 0,
      }
    },

    created: function () {
      this.pageLoad();
    },
    methods: {
      pageLoad: function () {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/getEntryTestList')
          .then(function (pl) {
            endReq();
            vm.tests = pl.data;
          })
      },

      loadHalls: function (id) {
        $('#modal').modal('show');
        var vm = this;
        vm.testID = id;
        startReq();
        axios.post('/api/AdmissionApi/loadHallsForEmail?id=' + vm.testID)
          .then(function (pl) {
            endReq();
            vm.halls = pl.data;
          })
      },

      sendEmail(hallID, type) {
        alert("It may take some time please do not refresh page");
        $('#myModal').modal('hide');
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/EmailAdmitCard?id=' + vm.testID + '&hallID=' + hallID + '&type=' + type)
          .then(function (pl) {
            endReq();
            alert("Email Send");
          })
      }
    }
  })

  //$(document).ready(function () {
  //  if (!$.fn.dataTable.isDataTable('#entryTestTable')) {
  //    var table = $('#entryTestTable').DataTable({
  //      "processing": true,
  //      "serverSide": true,
  //      "filter": true,
  //      "ajax": {
  //        "url": "/api/AdmissionApi/getEntryTestList",
  //        "type": "POST",
  //        "datatype": "json"
  //      },
  //      "columnDefs": [{
  //        "targets": [0],
  //        "visible": false,
  //        "searchable": false
  //      }],
  //      "columns": [
  //        { "data": "_Degree", "autoWidth": true },
  //        { "data": "_Session", "autoWidth": true },
  //        { "data": "Name", "autoWidth": true },
  //        { "data": "Timings", "autoWidth": true },
  //        {
  //          "render": function (data, type, row, meta) {
  //            return actions(data, type, row, meta);
  //          }
  //        },
  //      ]
  //    });
  //  }

  //  function actions(data, type, row, meta) {
  //    return "<a href='../Admission/EntryTestCreate?id=" + row.ID + "' target='_blank' class='btn btn-sm btn-primary' id='" + row.ID + "'>Edit</a> " +
  //      "<a href='../Admission/EntryTestPrint?id=" + row.ID + "' target='_blank' class='btn btn-sm btn-success' id='" + row.ID + "'>Print</a> " +
  //      "<a href='../Admission/EntryTestAttendanceSheetPrint?id=" + row.ID + "' target='_blank' class='btn btn-sm btn-warning' id='" + row.ID + "'>Attend. Sheet</a> " +
  //      "<a href='../Admission/EntryTestMarkSheetPrint?id=" + row.ID + "' target='_blank' class='btn btn-sm btn-info' id='" + row.ID + "'>Mark Sheet</a> " +
  //      "<a href='../Admission/EmailAdmitCard?id=" + row.ID + "' target='_blank' class='btn btn-sm btn-info' id='" + row.ID + "'>Email Admit Card</a> "
  //  }
  //});
</script>





// WEBPACK FOOTER //
// src/components/onlineadmission/entryTestList.vue